"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactTippy = require("react-tippy");
var CustomTooltip = function CustomTooltip(_ref) {
  var title = _ref.title,
    position = _ref.position,
    trigger = _ref.trigger,
    children = _ref.children,
    animation = _ref.animation,
    theme = _ref.theme,
    arrow = _ref.arrow,
    inertia = _ref.inertia,
    content = _ref.content,
    className = _ref.className,
    disabled = _ref.disabled,
    style = _ref.style,
    interactive = _ref.interactive;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-c-tooltip ".concat(className)
  }, /*#__PURE__*/_react["default"].createElement(_reactTippy.Tooltip, {
    className: className,
    title: title,
    disabled: disabled,
    html: content,
    trigger: trigger,
    animation: animation,
    theme: theme,
    arrow: arrow,
    inertia: inertia,
    position: position,
    sticky: true,
    stickyDuration: 0,
    style: style,
    popperOptions: {
      modifiers: {
        preventOverflow: {
          boundariesElement: 'window'
        }
      }
    },
    interactive: interactive,
    useContext: true
  }, children));
};
CustomTooltip.propTypes = {
  title: _propTypes["default"].string,
  content: _propTypes["default"].node,
  position: _propTypes["default"].string,
  trigger: _propTypes["default"].string,
  animation: _propTypes["default"].string,
  theme: _propTypes["default"].string,
  arrow: _propTypes["default"].bool,
  inertia: _propTypes["default"].bool,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  className: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  interactive: _propTypes["default"].bool,
  style: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array])
};
CustomTooltip.defaultProps = {
  trigger: 'mouseenter focus',
  position: 'top',
  animation: 'scale',
  theme: 'dark',
  arrow: true,
  inertia: true
};
var _default = exports["default"] = CustomTooltip;